{
    "Profile_Residents_CancellationReason.cancellation": "FR: Cancellation",
    "Profile_Residents_CancellationReason.cancellationDetails": "FR: Cancellation Details",
    "Profile_Residents_CancellationReason.dateOfCancellation": "FR: Date of Cancellation",
    "Profile_Residents_CancellationReason.cancellationReason": "FR: Cancellation Reason"
}
